import type { JSX } from 'react';
import { Badge, Box, Text } from '@ksyos/design-system';
import { useTheme } from 'styled-components';

interface IFilterButtonProps {
    isActive?: boolean;
    onClick: () => void;
    overdue: number;
    title: string;
    total: number;
}

export function OutclinicDashboardFilterButton(props: Readonly<IFilterButtonProps>): JSX.Element {
    const { title, overdue, total, onClick, isActive } = props;
    const theme = useTheme();

    const baseStyles = {
        '&:focus': {
            outline: 0,
        },
        '&:hover': {
            borderColor: theme.colors.blue500,
        },
        outline: 0,
    };

    const styles = isActive
        ? { ...baseStyles, borderColor: theme.colors.blue500, boxShadow: `0 0 0 4px ${theme.colors.blue50}` }
        : baseStyles;

    return (
        <Box
            alignItems="center"
            as="button"
            backgroundColor="white"
            border="1px solid transparent"
            borderRadius="base"
            display="flex"
            height={54}
            mt={4}
            onClick={onClick}
            px={3.5}
            py={3}
            sx={styles}
            title={title}
            width={1}
        >
            <Text
                color="subtle"
                fontSize="sm"
                sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }}
                whiteSpace="nowrap"
            >
                {title}
            </Text>
            <Box
                display="flex"
                sx={{ marginLeft: 'auto' }}
            >
                {overdue > 0 && (
                    <Badge
                        color="orange"
                        size="small"
                        sx={{
                            mr: 2,
                        }}
                        text={`${overdue} te laat`}
                    />
                )}
                <Badge
                    color="neutral"
                    size="small"
                    sx={{ marginLeft: 'auto', width: '32px' }}
                    text={`${total}`}
                />
            </Box>
        </Box>
    );
}
